var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNew({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#04B505"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9257 10.9333H14.3507V4.93332C14.3507 3.53332 13.5924 3.24999 12.6674 4.29999L12.0007 5.05832L6.35908 11.475C5.58408 12.35 5.90908 13.0667 7.07574 13.0667H9.65074V19.0667C9.65074 20.4667 10.4091 20.75 11.3341 19.7L12.0007 18.9417L17.6424 12.525C18.4174 11.65 18.0924 10.9333 16.9257 10.9333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNew);
export default __webpack_public_path__ + "static/media/new.44105fb72ed0583f410562fa48e2e06f.svg";
export { ForwardRef as ReactComponent };